import React from 'react';
import { styles } from './ReservationStyles';

const DeleteModal = ({ onClose, onConfirm }) => {
  // Brand Color for deletion (standard red)
  const dangerRed = '#EF4444';

  return (
    <div style={customStyles.overlay}>
      <div style={customStyles.modalCard}>
        {/* Warning Icon Section */}
        <div style={customStyles.iconWrapper}>
          <div style={customStyles.iconCircle}>
            <i className="fas fa-trash-alt" style={{ color: dangerRed, fontSize: '24px' }}></i>
          </div>
        </div>

        {/* Content Section */}
        <div style={{ padding: '0 25px', textAlign: 'center' }}>
          <h2 style={customStyles.title}>Confirm Deletion</h2>
          <p style={customStyles.message}>
            Are you sure you want to delete this reservation? 
            This action <span style={{ fontWeight: '700', color: '#111827' }}>cannot be undone</span>.
          </p>
        </div>

        {/* Action Buttons */}
        <div style={customStyles.buttonGroup}>
          <button
            type="button"
            style={customStyles.cancelBtn}
            onClick={onClose}
          >
            No, Cancel
          </button>
          <button
            type="button"
            style={{ ...customStyles.deleteBtn, backgroundColor: dangerRed }}
            onClick={onConfirm}
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};

// --- Modern UI Styles ---
const customStyles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 3000,
  },
  modalCard: {
    backgroundColor: '#ffffff',
    width: '90%',
    maxWidth: '380px',
    borderRadius: '20px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    paddingBottom: '20px'
  },
  iconWrapper: {
    padding: '30px 0 15px',
    display: 'flex',
    justifyContent: 'center',
  },
  iconCircle: {
    width: '64px',
    height: '64px',
    backgroundColor: '#FEE2E2',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    margin: '0 0 10px',
    fontSize: '20px',
    fontWeight: '700',
    color: '#111827',
  },
  message: {
    margin: 0,
    fontSize: '14px',
    color: '#6B7280',
    lineHeight: '1.6',
  },
  buttonGroup: {
    padding: '25px',
    display: 'flex',
    gap: '12px',
  },
  cancelBtn: {
    flex: 1,
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid #E5E7EB',
    backgroundColor: '#FFFFFF',
    color: '#374151',
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  deleteBtn: {
    flex: 1,
    padding: '12px',
    borderRadius: '10px',
    border: 'none',
    color: '#FFFFFF',
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.2)',
  },
};

export default DeleteModal;